module.exports = __webpack_public_path__ + "static/img/userLogo.f22cd6d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/designSrote/userLogo.jpeg
// module id = n9gu
// module chunks = 2